import dayjs from 'dayjs'

export function getMonthsNames(locale: string, format = 'MMMM') {
    const names = []
    let date = dayjs().calendar('jalali').set('month', 0).set('day', 1).startOf('month')

    for (let i = 0; i < 12; i += 1) {
        names.push(dayjs(date, { jalali: true }).calendar('jalali').locale(locale).format(format))
        date = dayjs(date, { jalali: true }).calendar('jalali').add(1, 'month')
    }

    return names
}
